import FAQModule from '@features/FAQ/components/FAQ.Module';
import React from 'react';

const FAQ = () => {
  return <FAQModule />;
};

export default FAQ;
